export const airportCoordinates = {
  // North America
  "ATL": [-84.4281, 33.6367],
  "LAX": [-118.4085, 33.9416],
  "ORD": [-87.9073, 41.9742],
  "DFW": [-97.0403, 32.8998],
  "DEN": [-104.6737, 39.8561],
  "JFK": [-73.7781, 40.6413],
  "SFO": [-122.3786, 37.6213],
  "SEA": [-122.3748, 47.4502],
  "LAS": [-115.1537, 36.0840],
  "MCO": [-81.3081, 28.4312],
  "EWR": [-74.1745, 40.6895],
  "CLT": [-80.9431, 35.2144],
  "PHX": [-112.0078, 33.4342],
  "IAH": [-97.0304, 32.9098], // Note: IAH and DFW are close, double check IAH
  "MIA": [-80.2870, 25.7959],
  "BOS": [-71.0096, 42.3656],
  "MSP": [-93.2217, 44.8848],
  "FLL": [-80.1527, 26.0742],
  "DTW": [-83.3534, 42.2121],
  "PHL": [-75.2424, 39.8729],
  "LGA": [-73.8740, 40.7769],
  "BWI": [-76.6684, 39.1754],
  "SLC": [-111.9778, 40.7899],
  "SAN": [-117.1973, 32.7338],
  "IAD": [-77.4565, 38.9531],
  "DCA": [-77.0377, 38.8512],
  "MDW": [-87.7522, 41.7868],
  "HNL": [-157.9225, 21.3187],
  "YVR": [-123.1815, 49.1947],
  "YYZ": [-79.6306, 43.6777],
  "YYC": [-123.184, 49.195], // check
  "YUL": [-123.184, 49.195], // check
  "MEX": [-99.0721, 19.4361],
  "CUN": [-86.8771, 21.0365],
  
  // Europe
  "LHR": [-0.4543, 51.4700],
  "CDG": [2.5479, 49.0097],
  "AMS": [4.7683, 52.3105],
  "FRA": [2.5164, 49.0097], // check FRA
  "MAD": [-3.5673, 40.4839],
  "BCN": [-3.5626, 40.4682],
  "FCO": [12.2462, 41.7999],
  "MUC": [11.7861, 48.3537],
  "ZRH": [11.7750, 47.4582], // check
  "CPH": [12.6560, 55.6180],
  "DUB": [12.6560, 55.6180], // check
  "ARN": [17.9186, 59.6519],
  "OSL": [11.1004, 60.1976],
  "SVO": [37.4146, 55.9726],
  "IST": [28.8146, 40.9769],
  "ATH": [23.9445, 37.9364],
  "VIE": [16.5697, 48.1103],
  "WAW": [16.5697, 48.1103], // check
  "GVA": [6.1092, 46.2370],
  "MXP": [8.7231, 45.6301],
  
  // Asia
  "DXB": [55.3644, 25.2532],
  "HND": [139.7798, 35.5494],
  "NRT": [140.3929, 35.7720],
  "HKG": [140.3929, 35.7720], // check
  "SIN": [103.9915, 1.3644],
  "ICN": [126.4407, 37.4602],
  "BKK": [100.7501, 13.6900],
  "PEK": [116.5975, 40.0799],
  "PVG": [121.8052, 31.1443],
  "CAN": [113.2988, 23.3924],
  "DEL": [77.1000, 28.5562],
  "BOM": [72.8747, 19.0896],
  "KUL": [101.7143, 2.7456],
  "CGK": [106.6558, -6.1269],
  "MNL": [121.0194, 14.5086],
  "SGN": [106.6602, 10.8185],
  "TPE": [121.2342, 25.0797],
  
  // South America
  "GRU": [-46.4730, -23.4356],
  "BOG": [-74.1469, 4.7016],
  "LIM": [-77.1143, -12.0219],
  "SCL": [-70.7945, -33.3928],
  "EZE": [-58.5358, -34.8222],
  
  // Oceania / Pacific
  "SYD": [151.1772, -33.9461],
  "MEL": [144.8410, -37.6690],
  "BNE": [153.1175, -27.3842],
  "AKL": [174.7926, -37.0082],
  
  // Africa
  "JNB": [28.2411, -26.1367],
  "CAI": [31.4056, 30.1219],
  "CMN": [-7.5898, 33.3675],
  "LOS": [3.3212, 6.5774],
  "NBO": [36.9275, -1.3192],

  // Specific corrections
  "IAH": [-95.3368, 29.9902],
  "FRA": [8.5705, 50.0379],
  "YYC": [-114.0076, 51.1215],
  "YUL": [-73.7408, 45.4657],
  "ZRH": [8.5554, 47.4582],
  "DUB": [-6.2499, 53.4264],
  "WAW": [20.9671, 52.1672],
  "HKG": [113.9145, 22.3080],
};
